import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function createOrUpdateProfile(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/user/profile/createOrUpdate`, data, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
